import { typeBuilder } from "base/shared/TypeHelper";

export default typeBuilder(["SET_STATUS", "SET_SOCKET"]);
